module.exports = __webpack_public_path__ + "img/logoWithTitle_icon.a2e6e21d.png";